import { AfterViewInit, Directive, ElementRef } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'ngx-avatar' })
export class NgxAvatarFixDirective implements AfterViewInit {
  constructor(private readonly elRef: ElementRef) {}

  ngAfterViewInit() {
    const img = (this.elRef.nativeElement as HTMLElement).querySelector('img');

    if (img) {
      // Fixes 403 errors when fetching avatars from Google
      //
      // https://stackoverflow.com/questions/40570117/http403-forbidden-error-when-trying-to-load-img-src-with-google-profile-pic/61042200#61042200
      img.referrerPolicy = 'no-referrer';
    }
  }
}
